import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputMaskModule } from 'primeng/inputmask';
import { ControlFieldComponent } from '../control-field/control-field.component';
import { PrimeNgControlComponent } from '../prime-ng-control/prime-ng-control.component';

@Component({
  selector: 'ui-zip-code-field',
  standalone: true,
  imports: [InputMaskModule, ControlFieldComponent, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ZipCodeFieldComponent),
      multi: true,
    },
  ],
  templateUrl: './zip-code-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZipCodeFieldComponent extends PrimeNgControlComponent<string> {}
